import React from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { LogIn, LogOut /* , Bell */ } from "lucide-react";
import { trackEvent } from '../config/amplitude';

interface HeaderProps {
  isAuthenticated: boolean;
  onLogout: () => void;
  onLogin: () => void;
  // onOpenAlert: () => void;
}

export const Header = ({ 
  isAuthenticated, 
  onLogout, 
  onLogin, 
}: HeaderProps) => {
  const location = useLocation();
  const isFeedPage = location.pathname === '/feed';

  const handleLogin = () => {
    trackEvent('Login Clicked');
    onLogin();
  };

  const handleLogout = () => {
    trackEvent('Logout Clicked');
    onLogout();
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-sm z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="text-2xl font-bold text-sky-500 flex items-center">
            Spriglaunch
            <span className="ml-2 text-xs bg-sky-100 text-sky-600 px-2 py-0.5 rounded-full font-medium">
              BETA
            </span>
          </Link>

          <div className="absolute left-1/2 -translate-x-1/2 flex items-center space-x-6">
            <Link
              to="/feed"
              className={`transition-colors ${
                location.pathname === '/feed'
                ? 'text-gray-900 font-semibold border-b-2 border-sky-500'
                : 'text-gray-600 hover:text-slate-800'
              }`}
            >
              Feed
            </Link>
            <div className="relative group">
              {isAuthenticated ? (
                <Link 
                  to="/analytics" 
                  className={`transition-colors ${
                    location.pathname === '/analytics'
                    ? 'text-gray-900 font-semibold border-b-2 border-sky-500'
                    : 'text-gray-600 hover:text-slate-800'
                  }`}
                >
                  Analytics
                </Link>
              ) : (
                <span 
                  className="text-gray-400 cursor-not-allowed"
                  onClick={(e) => e.preventDefault()}
                >
                  Analytics
                  <div className="absolute invisible group-hover:visible bg-gray-800 text-white text-xs rounded py-1 px-2 -bottom-8 left-1/2 transform -translate-x-1/2 w-max">
                    Login to track your comment performance
                  </div>
                </span>
              )}
            </div>
            <div className="relative group">
              {isAuthenticated ? (
                <Link
                  to="/settings"
                  className={`transition-colors ${
                    location.pathname === '/settings'
                    ? 'text-gray-900 font-semibold border-b-2 border-sky-500'
                    : 'text-gray-600 hover:text-slate-800'
                  }`}
                >
                  Settings
                </Link>
              ) : (
                <span 
                  className="text-gray-400 cursor-not-allowed"
                  onClick={(e) => e.preventDefault()}
                >
                  Settings
                  <div className="absolute invisible group-hover:visible bg-gray-800 text-white text-xs rounded py-1 px-2 -bottom-8 left-1/2 transform -translate-x-1/2 w-max">
                    Login to customize your feed and keywords
                  </div>
                </span>
              )}
            </div>
          </div>
         
          <div className="flex items-center space-x-4">
            {!isAuthenticated ? (
              <div className="relative group">
                <button
                  onClick={handleLogin}
                  className="px-4 py-2 text-sm font-medium text-white bg-purple-600 rounded-lg hover:bg-purple-700 transition-colors"
                >
                  Login with Reddit
                </button>
                <div className="absolute right-0 mt-2 w-64 p-4 bg-white rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  <div className="text-sm text-gray-600 space-y-2">
                    <p className="font-medium text-gray-900">Login to:</p>
                    <ul className="list-disc list-inside space-y-1">
                      <li>Save your keywords</li>
                      <li>Track your comments</li>
                      <li>Get personalized feed</li>
                    </ul>
                  </div>
                </div>
              </div>
            ) : (
              <button
                onClick={handleLogout}
                className="flex items-center space-x-2 text-gray-600 hover:text-sky-500 transition-colors px-3 py-1 rounded-lg border border-gray-200 hover:border-sky-200 text-sm"
                title="Logout"
              >
                <LogOut size={16} />
                <span>Logout</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};
